"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = require("services/page/app");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var mobx_1 = require("mobx");
var MProductsStore = (function () {
    function MProductsStore(modules) {
        var _this = this;
        this.productsListMap = {};
        this.productsPage = {};
        this.viewMoreLink = {};
        this.productsLimit = {};
        this.isLoadEnd = {};
        this.productsLoadMore = {};
        this.isLoadingProducts = {};
        this.offset = {};
        this.productLoadLimit = 20;
        this.loadProductsList = function (poolId, pages) {
            if (pages === void 0) { pages = Math.max(1, +(_this.productsPage[poolId] || 1)); }
            return __awaiter(_this, void 0, void 0, function () {
                var limit, productLimit, newLimit_1, resp_1, err_1;
                var _a, _b;
                var _this = this;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            pages = Math.max(1, pages);
                            limit = (this.productsLimit && this.productsLimit[poolId]) || this.productLoadLimit;
                            if (this.isLoadEnd[poolId] || this.isLoadingProducts[poolId]) {
                                return [2];
                            }
                            mobx_1.set(this.isLoadingProducts, (_a = {}, _a[poolId] = true, _a));
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, 4, 5]);
                            productLimit = Math.min(limit, this.productLoadLimit);
                            newLimit_1 = productLimit;
                            if (!this.productsLoadMore[poolId]) {
                                newLimit_1 =
                                    pages * productLimit > limit
                                        ? limit -
                                            (mobx_1.toJS(this.productsListMap[poolId]) ? mobx_1.toJS(this.productsListMap[poolId]).length : 0)
                                        : productLimit;
                            }
                            mobx_1.set(this.offset, (_b = {}, _b[poolId] = this.offset[poolId] ? this.offset[poolId] : 0, _b));
                            return [4, app_1.GetProducts({
                                    poolId: poolId,
                                    limit: newLimit_1 + "",
                                    offset: this.offset[poolId] + "",
                                    meta: this.meta
                                })];
                        case 2:
                            resp_1 = _c.sent();
                            if (resp_1 && Array.isArray(mobx_1.toJS(resp_1.products))) {
                                mobx_1.runInAction(function () {
                                    var _a, _b, _c, _d, _e;
                                    var products = _this.productsListMap[poolId];
                                    mobx_1.set(_this.offset, (_a = {}, _a[poolId] = Number(newLimit_1) + Number(_this.offset[poolId]), _a));
                                    if (!products) {
                                        mobx_1.set(_this.productsListMap, (_b = {}, _b[poolId] = resp_1.products, _b));
                                    }
                                    else {
                                        mobx_1.set(_this.productsListMap, (_c = {}, _c[poolId] = products.concat(resp_1.products), _c));
                                    }
                                    if (pages > 1) {
                                        mobx_1.set(_this.productsPage, (_d = {}, _d[poolId] = pages, _d));
                                    }
                                    if (!resp_1.hasNext ||
                                        (_this.productsListMap[poolId].length >= limit && !_this.productsLoadMore[poolId])) {
                                        mobx_1.set(_this.isLoadEnd, (_e = {}, _e[poolId] = true, _e));
                                    }
                                });
                            }
                            else {
                                mobx_1.runInAction(function () {
                                    var _a;
                                    mobx_1.set(_this.isLoadEnd, (_a = {}, _a[poolId] = true, _a));
                                });
                            }
                            return [3, 5];
                        case 3:
                            err_1 = _c.sent();
                            console.error("GetProducts Got error", err_1);
                            return [3, 5];
                        case 4:
                            mobx_1.runInAction(function () {
                                var _a;
                                mobx_1.set(_this.isLoadingProducts, (_a = {}, _a[poolId] = false, _a));
                            });
                            return [7];
                        case 5: return [2];
                    }
                });
            });
        };
        this.meta = {
            catalog: isomorphismConstant_1.default.country,
            lang: isomorphismConstant_1.default.language,
            client: "mweb",
            priceSymbol: isomorphismConstant_1.default.currency,
            userInfos: {}
        };
        modules.forEach(function (item) {
            var _a, _b, _c, _d;
            mobx_1.set(_this.productsLoadMore, (_a = {}, _a[item.poolId] = item.canLoadMore, _a));
            if (!item.canLoadMore) {
                mobx_1.set(_this.productsLimit, (_b = {}, _b[item.poolId] = item.maxLoad, _b));
                mobx_1.set(_this.viewMoreLink, (_c = {}, _c[item.poolId] = item.link, _c));
            }
            else {
                mobx_1.set(_this.productsLimit, (_d = {}, _d[item.poolId] = _this.productLoadLimit, _d));
            }
        });
    }
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "productsListMap", void 0);
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "productsPage", void 0);
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "viewMoreLink", void 0);
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "productsLimit", void 0);
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "isLoadEnd", void 0);
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "productsLoadMore", void 0);
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "isLoadingProducts", void 0);
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "offset", void 0);
    __decorate([
        mobx_1.observable
    ], MProductsStore.prototype, "productLoadLimit", void 0);
    __decorate([
        mobx_1.action
    ], MProductsStore.prototype, "loadProductsList", void 0);
    return MProductsStore;
}());
exports.default = MProductsStore;
